
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16","height":"16","width":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#000000","fill":"none","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M14.795 1.21a2.42 2.42 0 00-3.424.008l-.014.015-9.644 9.64L.5 15.5l4.628-1.213 9.643-9.64a2.419 2.419 0 00.04-3.42l-.016-.018zM11.08 1.509l3.415 3.413M9.688 2.9l3.415 3.414","stroke-width":"1.000005"}}),_c('path',{attrs:{"d":"M1.713 10.873l2.394 1.022 1.024 2.389M11.395 4.607l-7.288 7.287","stroke-width":"1.000005"}})])])
          )
        }
      }
    